export default __webpack_public_path__ + "media/images/arrow-8a6a1448109450d98c8d8d4f81ac5871.svg";